import styled from "styled-components";
export const Slidecss = styled.div`
  border:3px solid white;
  background-color: white;
  box-shadow: 0px 2px 3px #cccccc;
  padding: 4%;
  margin: 10px;
  border-radius:8px;
  transition:all.5s;
  :hover{
    border: 3px solid #ff7035;
  }
`;
